import client from './client'

export const authenticate$ = () =>
  client({ ignoreCache: true, ignoreLoadingState: true, path: '/auth/token' })

export const getSessionFromUser = (user) => ({
  sub: {
    id: user.id,
    user_name: user.user_name,
    firstname: user.firstname,
    lastname: user.lastname,
    superadmin: user.is_admin,
    administrator: user.roles.findIndex((r) => r.name === 'administrator') > -1
  }
})

export const login$ = (username, password) =>
  client({
    body: username && password ? { username, password } : {},
    method: 'POST',
    path: '/auth/login'
  })

export const logout$ = () => client({ method: 'POST', path: '/auth/logout' })

export const salesview$ = (id) =>
  client({ path: `/emma/report/${id}/salesview` })

const adapter = { authenticate$, login$, logout$, salesview$ }

export default adapter
